import React from 'react';

// Catches failures loading the lazy-loaded CropModal chunk (e.g. a dropped
// network request for the JS chunk) — React.lazy/Suspense only handles the
// *pending* state; an actual load failure surfaces as a thrown error during
// render, which needs a real error boundary. Class-only: React 16 has no
// hooks equivalent for getDerivedStateFromError/componentDidCatch.
class CropLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Failed to load the photo crop editor.', error, info);
    this.props.onError(error);
  }

  render() {
    // Render nothing once caught; the parent's onError is expected to
    // reset whatever prop (e.g. cropSrc) is causing this subtree to
    // mount, which unmounts this boundary and clears hasError for the
    // next attempt.
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default CropLoadErrorBoundary;
